import { createContext } from "react";

export const StoreContext = createContext({
  isAdmin: false,
  users: [],
  companies: [],
  companyOptions: [],
  schools: [],
  vehicles: [],
  students: [],
  drivers: [],
  driverOptions: [],
  vehicleRoutes: [],
  schoolOptions: [],
  stopOptions: [],
  studentOptions: [],
  parentOptions: [],
  personelOptions: [],
  relations: [],
  storeReady: false,
  isProcessing: false,
  studentRoutes: [],
  contracts: [],
  educationYears: [],
  discounts: [],
  serviceTemplates: [],
  educationYearsOptions: [],
  discountOptions: [],
  serviceTemplateOptions: [],
  receipts: [],
  withdraws: [],
  contractsOptions: [],
  expenses: [],
  vehicleRouteOptions: [],
  vehiclePayments: [],
  transfers: [],
  pLocations: [],
  pLocationsOptions: [],
  transferregions: [],
  transferregionOptions: [],
  ikarusTransfers: [],
  ikarusTransferRegions: [],
  ikarusTransferRegionOptions: [],
  ikarusTransferPassengers: [],
  ikarusTransferPassengerOptions: [],
  shifts: [],
  stops: [],
  userOptions: [],
  shiftOptions: [],
  shiftUsers: [],
  shiftUserOptions: [],
  // Personel Services
  standartPersonelServices: [],
  standartPersonelServiceOptions: [],
  shiftPersonelServices: [],
  shiftPersonelServiceOptions: [],

  // Functions
  UpdateVehicles: () => {},
  UpdateVehicleRoutes: () => {},
  UpdateCompanies: () => {},
  UpdateSchools: () => {},
  UpdateRelations: () => {},
  UpdateUsers: () => {},
  InsertUser: (user) => {},
  UpdateUser: (user) => {},
  DeleteUser: (userId) => {},
  UpdatePersonelServices: () => {},
  InsertPersonelService: (service) => {},
  UpdatePersonelService: (service) => {},
  DeletePersonelService: (serviceId) => {},
  InsertShift: (shift) => {},
  UpdateShift: (shift) => {},
  DeleteShift: (shiftId) => {},
  InsertStop: (stop) => {},
  UpdateStop: (stop) => {},
  DeleteStop: (stopId) => {},
  InsertVehicleRoute: (vehicleRoute) => {},
  UpdateVehicleRoute: (vehicleRoute) => {},
  DeleteVehicleRoute: (vehicleRouteId) => {},
  UpdateTransfers: () => {},
  UpdateStudents: async () => {},
  UpdateEverything: (school) => {},
  UpdateContracts: async () => {},
  UpdateReceipts: () => {},
  UpdateWithdraws: () => {},
  UpdateAccountingUtils: () => {},
  UpdateExpenses: () => {},
  UpdateVehiclePayments: () => {},
  UpdatePLocations: () => {},
  UpdateTransferregions: () => {},
  UpdateIkarusTransfers: () => {},
  UpdateIkarusTransferRegions: () => {},
  UpdateIkarusTransferPassengers: () => {},
  UpdateShifts: () => {},
  UpdateStops: () => {},
});
